import { Permission } from '@procureai/permissions';
import { PermissionCheck, usePermissions } from '@procureai/permissions-ui';
import { Navigate } from 'react-router-dom';

import { RouteId } from '../RouteId';

type LandingPages = 'cockpit' | 'demand' | 'intake' | 'intakeCreate' | 'analytics' | 'home';
type LandingPageConfig = {
  permissionCheck: PermissionCheck;
  route: string;
};

const landingPageHierarchy: LandingPages[] = ['demand', 'cockpit', 'intake', 'intakeCreate', 'analytics'];

const landingPageConfigMap: { [key in LandingPages]: LandingPageConfig } = {
  cockpit: {
    permissionCheck: { all: [Permission.HomeCockpit, Permission.RouteCockpit] },
    route: RouteId.cockpit,
  },
  demand: {
    permissionCheck: { all: [Permission.HomeDemand, Permission.DemandList] },
    route: RouteId.demand,
  },
  intake: {
    permissionCheck: { all: [Permission.HomeIntake, Permission.IntakeList] },
    route: RouteId.intake,
  },
  intakeCreate: {
    permissionCheck: { all: [Permission.HomeIntakeCreate, Permission.IntakeCreate] },
    route: RouteId.intakeCreate,
  },
  analytics: {
    permissionCheck: { all: [Permission.HomeAnalytics, Permission.BaseGeneral] },
    route: RouteId.analyticsGeneral,
  },
  home: {
    // accessible to all users, fallback for routing if no permissions granted
    // as fallback, the permission check is not verified but included for type safety
    // and will actually always yield 'true' in the usePermissions hook
    permissionCheck: { all: [] },
    route: RouteId.home,
  },
};

export const LandingPage = () => {
  const { hasPermission } = usePermissions();

  for (const landingPage of landingPageHierarchy) {
    const { permissionCheck, route } = landingPageConfigMap[landingPage];
    if (hasPermission(permissionCheck)) {
      return <Navigate replace to={route} />;
    }
  }
  return <Navigate replace to={landingPageConfigMap['home'].route} />;
};
